import {
  UseFormReset,
  UseFormResetField,
  UseFormSetValue,
} from "react-hook-form";
import {Process} from "views/ProcessDetails/refactor/types/process.types";
import {
  Voyage,
  VoyageToSend,
} from "views/ProcessDetails/refactor/types/voyages.types";
import {
  ID_COLLECT_VOYAGE,
  ID_RECEIVING_LOCATION,
} from "views/ProcessDetails/utils/constants";

export type VoyageDeletionContext = {
  previousVoyageDestination: {id: number | null; label: string | null} | null;
  deletedIndex: number;
  nextVoyage: Voyage | undefined;
  allVoyagesBeforeDeletion: Voyage[];
};

const getVoyageContextBeforeDeletion = (
  allVoyages: Voyage[],
  deletedIndex: number,
): VoyageDeletionContext => {
  const previousVoyage = allVoyages[deletedIndex - 1];
  const nextVoyage = allVoyages[deletedIndex + 1];

  return {
    previousVoyageDestination: previousVoyage?.destination
      ? {
          id: previousVoyage.destination.id,
          label: previousVoyage.destination.name,
        }
      : null,
    deletedIndex,
    nextVoyage,
    allVoyagesBeforeDeletion: allVoyages,
  };
};

const shouldUpdateNextVoyageOrigin = (voyage: Voyage, voyages: Voyage[]) => {
  const isCollectVoyage = voyage.typeVoyage?.id === ID_COLLECT_VOYAGE;
  const isReceivingLocation = voyage.typeVoyage?.id === ID_RECEIVING_LOCATION;
  const isLastVoyage = voyages[voyages.length - 1]?.id === voyage.id;

  if (isCollectVoyage || isLastVoyage || isReceivingLocation) {
    return false;
  }

  return true;
};

const updateNextVoyageOrigin = async (
  context: VoyageDeletionContext,
  processId: number,
  addNewVoyage: (
    id: number,
    voyage: Partial<VoyageToSend>,
  ) => Promise<Process | undefined>,
  setValue: UseFormSetValue<Process>,
  resetField: UseFormResetField<Process>,
  reset: UseFormReset<Process>,
): Promise<void> => {
  const {previousVoyageDestination, deletedIndex, nextVoyage} = context;

  if (!nextVoyage) {
    return;
  }

  const originValue = previousVoyageDestination
    ? {
        id: previousVoyageDestination.id,
        name: previousVoyageDestination.label,
      }
    : {
        id: null,
        name: null,
      };

  setValue(
    `boarding.voyages[${deletedIndex}].origin` as `boarding.voyages.0.origin`,
    originValue,
    {shouldDirty: false},
  );

  const result = await addNewVoyage(processId, {
    id: nextVoyage.id,
    idOrigin: originValue.id,
  });

  reset(result);
  resetField("boarding.voyages");
};

export {
  shouldUpdateNextVoyageOrigin,
  getVoyageContextBeforeDeletion,
  updateNextVoyageOrigin,
};
